export default __webpack_public_path__ + "static/media/studentuplift.3fbb708e.webp";